import { render } from "./PropertiesEditing.vue?vue&type=template&id=025cca90&ts=true"
import script from "./PropertiesEditing.vue?vue&type=script&lang=ts"
export * from "./PropertiesEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__